/**
 * create-subject-context-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { SubjectContextType } from "../../../subjects/subject-context-type";
import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link CreateSubjectContextRequest} to request the
 * creation of a brand new subject context for entry.
 */
export class CreateSubjectContextRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CREATE_SUBJECT_CONTEXT;
  public static tag : MessageTag = MessageTag.REQ_CREATE_SUBJECT_CONTEXT;

  /** Validate that the reply is a {@link SubjectContextResponse} */
  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT);
  }

  /**
   * Construct a new {@link CreateSubjectContextRequest}.
   */
  constructor (
    public type : SubjectContextType,
    public groupIds : number[],
    public asDuplicateOfCurrent : boolean = false
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/context-management/create-subject-context-request.ts